import { useState } from 'react';
import i18n from '@/i18n';
import { I18nResource } from '@/i18n/i18n-supported-language';

export const useAppLanguage = () => {
  const [language, setLanguageState] = useState(i18n.language); // useState to force rerender i18n.language

  const changeLanguage = (lang: I18nResource) => {
    i18n.changeLanguage(lang);
    setLanguageState(lang);
  };

  return {
    language,
    changeLanguage,
  };
};
